import type { GiantId } from '../../../domain/ids/ids';
import {
  deliveryDialogContentForGiant,
  type DeliveryDialogContent,
} from '../shared/deliveryDialogContent';

export type SuccessDeliveryScreenProps = {
  giantId: GiantId;
  orderIndex?: number;
  levelNameText?: string;
  giantNameText?: string;
  riddleText?: string;
  deliveryItemText?: string;
  answerText?: string;
  onViewResults?: () => void;
};

export type SuccessDeliveryScreenModel = {
  giantId: GiantId;
  orderIndex: number;
  levelNameText: string;
  giantNameText: string;
  riddleText: string;
  deliveryItemText: string;
  answerText: string;
  onViewResults?: () => void;
};

export function createSuccessDeliveryScreenModel(
  props: SuccessDeliveryScreenProps,
): SuccessDeliveryScreenModel {
  const orderIndex = props.orderIndex ?? 0;
  const content: DeliveryDialogContent = deliveryDialogContentForGiant(
    props.giantId,
    orderIndex,
  );

  return {
    giantId: props.giantId,
    orderIndex,
    levelNameText: props.levelNameText ?? content.levelNameText,
    giantNameText: props.giantNameText ?? content.giantNameText,
    riddleText: props.riddleText ?? content.riddleText,
    deliveryItemText: props.deliveryItemText ?? content.deliveryItemText,
    answerText: props.answerText ?? content.answerText,
    onViewResults: props.onViewResults,
  };
}
